
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Step Up</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm musical-comp section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>STEP <span >UP !!</span></h2>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>STEP <span class="small-sm">UP !!</span></h4>
                </div>

                <div class="fide-chess-text">
                    <p>Attention!! All Dancers & Performers,</p>
                </div>
                <p>
                    Step forward and take center stage at "I too have Talent" program.
                    One day dedicated to you and your Dance. Show off your skills.
                    Scout for Talents. Steal few moves in a room filled with an appreciative audience.
                </p>
                <br>
                <p>INTERESTED STUDENTS ARE ENCOURAGED TO SUBMIT AN ENTRY FOR THIS DANCE CONTEST.</p>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/stepup-banner.jpg"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-md-6">
                <iframe src="https://urlzs.com/xa5Ys" height="500" width="100%" class="iframe-sm"></iframe>
            </div>
            <div class="col-md-6">
                <iframe src="https://urlzs.com/V5pU4" height="500" width="100%" class="iframe-sm"></iframe>
            </div>
        </div>

    </div>
</section>
